import { Storage } from 'aws-amplify';

async function loadS3Image(s3Key) {
  const url = await Storage.get(s3Key);
  return url;
}

export default loadS3Image;
